module.exports = __webpack_public_path__ + "static/media/logo-kop.ceec94f4.png";